import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import levitatingImg from '../../../assets/images/levitating-paper.png';
import './ProjectPublishedModal.scss';
var ProjectPublishedModal = /*#__PURE__*/function (_Component) {
  function ProjectPublishedModal(props) {
    var _this;
    _classCallCheck(this, ProjectPublishedModal);
    _this = _callSuper(this, ProjectPublishedModal, [props]);
    _this.state = {
      showModal: true
    };
    _this.handleShowModal = _this.handleShowModal.bind(_this);
    _this.handleCloseModal = _this.handleCloseModal.bind(_this);
    return _this;
  }
  _inherits(ProjectPublishedModal, _Component);
  return _createClass(ProjectPublishedModal, [{
    key: "handleShowModal",
    value: function handleShowModal() {
      this.setState({
        showModal: true
      });
    }
  }, {
    key: "handleCloseModal",
    value: function handleCloseModal() {
      this.setState({
        showModal: false
      });
    }
  }, {
    key: "render",
    value: function render() {
      var showModal = this.state.showModal;
      var referralUrl = this.props.referralUrl;
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Modal, {
        show: showModal,
        onHide: this.handleCloseModal
      }, /*#__PURE__*/React.createElement(Modal.Header, {
        closeButton: true,
        className: "no-border-bottom"
      }), /*#__PURE__*/React.createElement(Modal.Body, null, /*#__PURE__*/React.createElement("div", {
        className: "project-published-modal style-guide"
      }, /*#__PURE__*/React.createElement("img", {
        src: levitatingImg,
        alt: "Clora",
        className: "levitating-img"
      }), /*#__PURE__*/React.createElement("h1", {
        className: "mb-12"
      }, "Clora is reviewing your project!"), /*#__PURE__*/React.createElement("div", {
        className: "body-text-1 mb-12"
      }, "Before making it public, we want to ensure your project post best represents your company's needs."), /*#__PURE__*/React.createElement("div", {
        className: "body-text-1 mb-4"
      }, "Your account manager will contact you shortly to schedule a scoping call."), /*#__PURE__*/React.createElement("hr", {
        className: "mt-0  mb-3 "
      }), /*#__PURE__*/React.createElement("div", {
        className: "body-text-1"
      }, "If you think Clora can benefit other employers in your network, check out our", ' ', /*#__PURE__*/React.createElement("strong", null, "Referral Program", /*#__PURE__*/React.createElement("a", {
        href: referralUrl,
        target: "_blank",
        id: "referral-from-published-project",
        rel: "noreferrer"
      }, ' ', "here")), ".")))));
    }
  }]);
}(Component);
ProjectPublishedModal.propTypes = {
  referralUrl: PropTypes.string.isRequired
};
export default ProjectPublishedModal;